export default "__VITE_ASSET__Wpm_$8J3__"